import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import EmailSignup from './EmailSignup';
import NavItems from './NavItems';

import logo from '../assets/images/logo_white.svg';
import github from '../assets/images/icons/github.svg';
import dribbble from '../assets/images/icons/dribbble.svg';
import twitter from '../assets/images/icons/twitter.svg';
import facebook from '../assets/images/icons/facebook.svg';
import youtube from '../assets/images/icons/youtube.svg';

import { e84_default_routes } from '../lib/routes';

const Footer = ({ routes = e84_default_routes }) => {

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="six columns">
            <p>
              <Link to="/" className="site-footer-title">
                <span className="text-hidden">Element 84</span>
                <img src={ logo }
                  alt="E84 Logo - Click for home page"
                  className="site-footer-logo"
                />
              </Link>
            </p>
            210 N. Lee Street
            <br />
            Suite 203 Alexandria, VA 22314
            <br />
            <a href="tel:+17036505490">703.650.5490</a>
            <NavItems modifier="footer" routes={ routes } />
          </div>
          <div className="six columns">
            <div className="row">
              <div className="ten columns offset-by-two">
                <EmailSignup label="Let’s keep in touch."
                  next="/about-us"
                  action="https://element84.us13.list-manage.com/subscribe/post?u=a7a7fcb1ce46c4d001fc76289&amp;id=567cefe1cc"
                />
              </div>
            </div>

            <ul className="footer-social">
              <li>
                <a href="https://github.com/element84"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ github } alt="Link to E84 Github" />
                </a>
              </li>
              <li>
                <a href="https://dribbble.com/e84"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ dribbble } alt="Link to E84 Dribbble" />
                </a>
              </li>
              <li>
                <a href="http://twitter.com/e84news"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ twitter } alt="Link to E84 Twitter" />
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/element84"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ facebook } alt="Link to E84 Facebook" />
                </a>
              </li>
              <li>
                <a href="https://www.youtube.com/channel/UCOEdB0SZcWbsvnwR5d2I7xA"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={ youtube } alt="Link to E84 YouTube" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );

};

Footer.propTypes = {
  routes: PropTypes.array,
};

export default Footer;
